import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';
import { environment } from 'environments/environment';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.style.css']
})
export class FullComponent implements OnDestroy, AfterViewInit {
  public layaoutExit:boolean;
  mobileQuery: MediaQueryList;
  elemento: HTMLElement;
  opened:boolean = true;
  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
     private loginS: LoginService
  ) {
    // this.elemento.ontoggle("toggled");
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    if (localStorage.getItem(environment.tokenLocal)){
      this.layaoutExit = true;
    }
// si no esta el token no podra ver esta pagina
    const MFX_01 = localStorage.getItem("MFX_01")
    const token = localStorage.getItem(environment.tokenLocal);
    if (MFX_01 === null || token === null) {
        this.loginS.cerrarSesion();
        this.router.navigateByUrl('/inicio');
      }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);

  }
  ngAfterViewInit() {}


}
